module.exports = __webpack_public_path__ + "img/Sylarna.ddf04b6b.jpg";